import { render, staticRenderFns } from "./buyer-broker.vue?vue&type=template&id=187c74b2"
import script from "./buyer-broker.vue?vue&type=script&lang=js"
export * from "./buyer-broker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports